import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { CardContent, Divider, List, ListItem, ListItemAvatar, ListItemText, Typography } from "@material-ui/core";
import { getUsersAboveUser } from "../../actions/Management";
import AbtcAvatar from "../../custom/Avatar";
import { CardPageItem } from "../../custom/Page";

const UsersAbove = ({ user, margin = 16, renderDivider, title = "app.users.above", titleColor = "inherit", titleAlign = "center", titleVariant = "subtitle1" }) => {
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      let usersData = await getUsersAboveUser(user.id);
      usersData = usersData.reverse();
      setUsers(usersData);
    };
    fetchData();
    setLoading(false);
  }, [user]);

  if (loading) return null;

  return (
    <CardPageItem
      raised
      margin={margin}
    >
      <CardContent>
        <Typography
          align={titleAlign}
          color={titleColor}
          variant={titleVariant}
        >
          <FormattedMessage id={title} />
        </Typography>
        {renderDivider && <Divider />}
        {users.length ? (
          <List>
            {users.map((user, index) => (
              <ListItem
                key={user.id}
                divider={index !== users.length - 1}
              >
                <ListItemAvatar>
                  <AbtcAvatar
                    photo={user.photo}
                    imageUrl={user.photoUrl}
                    disableLink
                  />
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <>
                      <Typography color="textPrimary">
                        {`${user.name} `}
                        <Typography
                          component={"span"}
                          color="textSecondary"
                        >
                          ({user.id})
                        </Typography>
                      </Typography>
                    </>
                  }
                  secondary={`${user.jobTitle} - ${user.email}`}
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Typography
            variant="body2"
            align="center"
            color="textSecondary"
            style={{ marginTop: 12 }}
          >
            <FormattedMessage id="app.users.above.none" />
          </Typography>
        )}
      </CardContent>
    </CardPageItem>
  );
};

export default React.memo(UsersAbove);
